export const LOAD_CONTENT = 'hg/moversConfirmation/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'hg/moversConfirmation/DL_PAGE_LOADED';
export const SET_DATA = 'hg/moversConfirmation/SET_DATA';

const initialState = {
  content: {
    currentEquipment: {
      equipments: []
    }
  }
};

export const moversConfirmation = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};

export default moversConfirmation;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/confirmation/confirmation.js
 **/